import o from "./ghl-ui.es846.js";
import t from "./ghl-ui.es847.js";
import a from "./ghl-ui.es848.js";
import r from "./ghl-ui.es849.js";
import m from "./ghl-ui.es850.js";
var e = {
  code: "sv",
  formatDistance: o,
  formatLong: t,
  formatRelative: a,
  localize: r,
  match: m,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const n = e;
export {
  n as default
};
